<template>
  <div>
    <div class="prompt" v-if="prompt">
      <v-container>
        <div>
          <h3>Installer l'application web</h3>
          <p>En ajoutant l'application web sur votre bureau un raccourci sera créé sans occuper d'expace sur votree appareil.</p>
        </div>
        <v-spacer></v-spacer>
        <v-btn class="primary ma-5" large v-on:click="install">Installer</v-btn>
        <v-btn class="ma-5" large v-on:click="prompt = !prompt; later = true;">Plus tard</v-btn>
      </v-container>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isStandalone: false,
      prompt: false,
      deferredPrompt: null,
      later: false,
    };
  },
  computed: mapState(["offsetTop"]),
  watch: {
    offsetTop() {
      // console.log(this.offsetTop, this.$store.state.offsetTop);
      if (
        this.offsetTop > window.innerHeight * 3 &&
        this.deferredPrompt &&
        !this.prompt &&
        !this.later
      ) {
        // this.prompt = true;
        this.prompter();
      } else if (this.offsetTop < window.innerHeight) {
        this.prompt = false;
      }
    },
  },
  mounted() {
    this.testInstall();
    window.addEventListener(
      "beforeinstallprompt",
      function (e) {
        e.preventDefault();
        this.deferredPrompt = e;
      }.bind(this)
    );
  },
  methods: {
    testInstall: function () {
      this.isStandalone = navigator.standalone;
      return navigator.standalone;
    },
    install: function () {
      this.prompt = false;
      // Show the install prompt
      this.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          // eslint-disable-next-line no-unused-vars
          window.addEventListener("appinstalled", function (evt) {
            // Log install to analytics
            // TODO STORE APP INSTALLED
          });
        } else {
          // TODO STORE APP NOT INSTALLED REJECTION
          this.later = true;
        }
      });
    },
    prompter: function () {
      // this.prompt = true;
    },
  },
};
</script>
<style scoped>
.prompt {
  z-index: 999;
  position: fixed;
  bottom: 0;
  left: 0;
  background: white;
  width: 100%;
  padding: 20px;
  display: flex;
  box-shadow: 0 -4px 0 0 rgba(59, 66, 177, 0.11);
}
</style>